export default [
    {
      path: '/upload/excel',
      name: 'admin-upload',
      component: () => import('@/views/upload-excel/upload.vue'),
      meta: {
        pageTitle: 'อัปโหลด',
        breadcrumb: [
          {
            text: 'อัปโหลด',
            active: true,
          },
        ],
        resource: 'TaobaoAdmin',
        action: 'manage',
      },
    },
    {
      path: '/admin/dashboard',
      name: 'admin-dashboard',
      component: () => import('@/views/admin/dashboard/dashboard.vue'),
      meta: {
        pageTitle: 'แดชบอร์ด',
        breadcrumb: [
          {
            text: 'แดชบอร์ด',
            active: true,
          },
        ],
        resource: 'TaobaoAdmin',
        action: 'manage',
      },
    },
    {
      path: '/admin/customer',
      name: 'admin-customer',
      component: () => import('@/views/admin/customer/customer.vue'),
      meta: {
        pageTitle: 'ข้อมูลลูกค้า',
        breadcrumb: [
          {
            text: 'ข้อมูลลูกค้า',
            active: true,
          },
        ],
        resource: 'TaobaoAdmin',
        action: 'manage',
      },
    },
    {
      path: '/admin/customer-detail',
      name: 'admin-customer-detail',
      component: () => import('@/views/admin/customer/customer-detail.vue'),
      meta: {
        pageTitle: 'รายละเอียดลูกค้า',
        breadcrumb: [
          {
            text: 'รายละเอียดลูกค้า',
            active: true,
          },
        ],
        resource: 'TaobaoAdmin',
        action: 'manage',
      },
    },

  ]